import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { CaseState } from 'app/area/case/types-store';
import {compile, RX_MATCH_INTERPOLATE_CONTENT} from 'app/infrastructure/js/template';
import { ApplicationState } from 'app/types-store';
import { createContext } from 'app/area/case/selectors/template-url/data-context';

/**
 * A selector that compiles a template url string against a predefined data context 
 * the template may select values from. 
 * Selected values replace it's matching template literals in the `templateUrl`.
 * 
 * `templateUrl` is retreived from the domain's attributes.
 * 
 * @param caseState 
 * @param uiEngineProps 
 * @param appState 
 */
export const templateURL =  
  (caseState: CaseState, uiEngineProps: ConnectedComponentProps, appState: ApplicationState) => { 
    const {templateUrl} = uiEngineProps.componentDescriptor.properties;
    let urlFromTemplateString = compile(templateUrl as string, createContext(appState,uiEngineProps));
    if(RX_MATCH_INTERPOLATE_CONTENT.test(urlFromTemplateString)){
      urlFromTemplateString = undefined;
    }
    return {
      urlFromTemplateString
    };
};
